import Result from "iotera-base/result";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { SizeMe } from "react-sizeme";
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap";
import { domainIsTenant as dit } from "../../../../../routes/routes";

import { Tooltip, Zoom } from "@material-ui/core";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableFooter from "@material-ui/core/TableFooter";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";

import { safeDeepGet, safeDeepGetWithType } from "iotera-base/json";
import { isInteger } from "iotera-base/object";

import { buildWBoundActions } from "../../../../../redux/ducks";

import {
  CustomTableCell,
  TablePaginationActionsWrapped,
} from "../../../../../custom/table";
import { getWidthColumnByPercent } from "../../../../../lib/components/function";

import "bootstrap/dist/css/bootstrap.min.css";
import "../alternative-style.css";

import {
  formatDate
} from '../../../data/detail/function';

import {
  setCallbackGlobal,
  unsetCallbackGlobal,
} from "../../../../../lib/components/callbackGlobal";

const dropdownItems = ["25", "50", "100"];

// declare golbal variabel tablelast
const FETCH_STATE_LATEST = "FETCH_STATE_LATEST";
const WKEY = "FETCH_STATE_LATEST";
const wBoundActions = buildWBoundActions(WKEY);

const TabLatest = (props) => {
  const [data, setData] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [dropdownOpen, setDropdownopen] = useState(false);
  let [dropdownLabel, setDropdownLabel] = useState(25);
  const [dataUObject, setDataUObject] = useState({});
  const [dialogUObject, setDialogUObject] = useState(false);
  const [selectedKey, setSelectedKey] = useState();

  useEffect(() => {
    let _props = props;
    const domainIsTenant = dit(_props);
    let deviceId = safeDeepGet(_props, ["match", "params", "id"]);
    let selected = safeDeepGet(_props, "selected");
    let key = safeDeepGet(selected, "key");
    // callback global
    setCallbackGlobal(_props);
    _props.wInitRequestCall({
      wparam: {
        ...domainIsTenant,
        path:
          "/service/web/state/records/newest",
        params: {
          device_id: deviceId,
          key,
          n: dropdownLabel
        }
      },
      wcallback: {
        started: function () {
          _props.cbLoading(true);
        },
        finished: function (id, result) {
          if (result.code === Result.HTTP.OK) {
            const responseResult = safeDeepGetWithType(
              result,
              ["body", "response_result"],
              Result.UNKNOWN_ERROR
            );
            if (responseResult === Result.SUCCESS) {
              setData(safeDeepGetWithType(result, ["body", "state_records"], []));
              _props.cbLoading(false);
            } else {
              _props.cbLoading(false);
            }
          } else {
            _props.cbLoading(false);
          }
        },
      },
    });
    return () => {
      // callback global
      unsetCallbackGlobal(_props);
      _props.wUnsetConfig({ key: WKEY });
    };
  }, []);

  useEffect(() => {
    let _props = props;
    const domainIsTenant = dit(_props);
    let deviceId = safeDeepGet(_props, ["match", "params", "id"]);
    let refresh = safeDeepGet(_props, ["refresh"]);
    // callback global
    setCallbackGlobal(_props);
    _props.wSetConfig({
      single_config: {
        [FETCH_STATE_LATEST]: {
          wparam: {
            ...domainIsTenant,
            path: "/service/web/state/records/newest",
            params: {
              device_id: deviceId,
            }
          },
          wcallback: {
            finished: function (id, result) {
              if (result.code === Result.HTTP.OK) {
                const responseResult = safeDeepGetWithType(
                  result,
                  ["body", "response_result"],
                  Result.UNKNOWN_ERROR
                );
                if (responseResult === Result.SUCCESS) {
                  setData(safeDeepGetWithType(result, ["body", "state_records"], []));
                  if (refresh) {
                    _props.cbRefresh(false);
                  }
                  _props.cbLoading(false);
                } else {
                  if (refresh) {
                    _props.cbRefresh(false);
                  }
                  _props.cbLoading(false);
                }
              } else {
                if (refresh) {
                  _props.cbRefresh(false);
                }
                _props.cbLoading(false);
              }
            },
          },
          wenv: { params: 'newest' },
        },
      },
    });
    return () => {
      // callback global
      unsetCallbackGlobal(_props);
      _props.wUnsetConfig({ key: WKEY });
    };
  }, []);

  const toggle = () => {
    setDropdownopen((prevState) => !prevState);
  };

  const handleDropdownItem = (e) => {
    setDropdownLabel((dropdownLabel = parseInt(e.target.innerText)));
    const _props = props;
    let selected = safeDeepGet(_props, "selected");
    let key = safeDeepGet(selected, "key");
    _props.wSetEnv({
      type: "params",
      env: "newest",
      value: {
        key,
        n: dropdownLabel,
      },
    });
    let deviceId = safeDeepGet(_props, ["match", "params", "id"]);
    let wsKey = WKEY + "_" + deviceId;
    _props.cbLoading(true);
    _props.wSingleRequestCall({
      id: FETCH_STATE_LATEST,
    });
  };

  const handleExpandNode = () => false;

  const handleChangePage = (event, page) => {
    setPage(page);
  };

  const handleChangeRowsPerPage = (event) => {
    let rowsPerPage = event.target.value;
    if (!isInteger(rowsPerPage)) rowsPerPage = parseInt(rowsPerPage);
    setPage(0);
    setRowsPerPage(rowsPerPage);
  };

  const handleClickUObject = (i, value) => (e) => {
    setDataUObject(value);
    setSelectedKey(i);
    setDialogUObject(true);
  };

  const handleCloseUObject = () => {
    setDialogUObject(false);
  };

  let _dataUObject = dataUObject;
  if (_dataUObject === null) {
    _dataUObject = {};
  }

  return (
    <div>
      <div className="d-flex justify-content-end">
        <Tooltip
          TransitionComponent={Zoom}
          title="Select amount of latest data"
          enterDelay={500}
          placement="left"
        >
          <div>
            <Dropdown isOpen={dropdownOpen} toggle={toggle}>
              <DropdownToggle caret>{dropdownLabel}</DropdownToggle>
              <DropdownMenu right className="p-0 m-0">
                {dropdownItems.map((dropdownItem, i) => (
                  <DropdownItem
                    key={i}
                    className="py-2 m-0 d-flex justify-content-center"
                    onClick={handleDropdownItem}
                  >
                    {dropdownItem}
                  </DropdownItem>
                ))}
              </DropdownMenu>
            </Dropdown>
          </div>
        </Tooltip>
      </div>
      <SizeMe>
        {({ size }) => (
          <div className="table-responsive mt-4">
            <Table className="table">
              <TableHead style={{ height: 0 }}>
                <TableRow>
                  <CustomTableCell
                    style={{
                      minWidth: getWidthColumnByPercent(20, size.width - 140),
                      maxWidth: getWidthColumnByPercent(20, size.width - 140),
                    }}
                  >
                    key
                  </CustomTableCell>
                  <CustomTableCell
                    style={{
                      minWidth: getWidthColumnByPercent(20, size.width - 140),
                      maxWidth: getWidthColumnByPercent(20, size.width - 140),
                    }}
                  >
                    value
                  </CustomTableCell>
                  <CustomTableCell
                    style={{
                      minWidth: getWidthColumnByPercent(20, size.width - 140),
                      maxWidth: getWidthColumnByPercent(20, size.width - 140),
                    }}
                  >
                    active
                  </CustomTableCell>
                  <CustomTableCell
                    style={{
                      minWidth: getWidthColumnByPercent(20, size.width - 140),
                      maxWidth: getWidthColumnByPercent(20, size.width - 140),
                    }}
                  >
                    initial
                  </CustomTableCell>
                  <CustomTableCell
                    style={{
                      minWidth: getWidthColumnByPercent(20, size.width - 140),
                      maxWidth: getWidthColumnByPercent(20, size.width - 140),
                    }}
                  >
                    latest
                  </CustomTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((item, i) => (
                    <TableRow key={i} className="table-row-child-iotera">
                      <TableCell>
                        {safeDeepGet(item, ['key'], "")}
                      </TableCell>
                      <TableCell>
                        {safeDeepGet(item, ['value'], "")}
                      </TableCell>
                      <TableCell>
                        {!safeDeepGet(item, ["is_null"]) ? "Active": "Inactive"}
                      </TableCell>
                      <TableCell>
                        <Tooltip title={item.initial_ts != null ? item.initial_ts : ""} leaveDelay={500} interactive><span>{formatDate(true, item.initial_ts)}</span></Tooltip>
                      </TableCell>
                      <TableCell>
                        <Tooltip title={item.latest_ts != null ? item.latest_ts : ""} leaveDelay={500} interactive><span>{formatDate(true, item.latest_ts)}</span></Tooltip>
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
              <TableFooter>
                <TableRow>
                  <TablePagination
                    labelDisplayedRows={({ from, to, count }) =>
                      `${from}-${to} dari ${count}`
                    }
                    labelRowsPerPage="Baris terlihat:"
                    rowsPerPageOptions={[25, 50, 100]}
                    count={data.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    SelectProps={{
                      native: true,
                    }}
                    onPageChange={handleChangePage}
                    onChangeRowsPerPage={handleChangeRowsPerPage}
                    ActionsComponent={TablePaginationActionsWrapped}
                  />
                </TableRow>
              </TableFooter>
            </Table>
          </div>
        )}
      </SizeMe>
    </div>
  );
};

const mapDispatchToProps = function (dispatch) {
  return {
    ...wBoundActions(dispatch),
  };
};

export default connect(null, mapDispatchToProps)(TabLatest);
